type SubmitButtonSessionProps = {
  isSubmitButtonDisabled: boolean;
  handleModalConfirmation: (res: string) => void;
};

export const SubmitButtonSession = ({
  isSubmitButtonDisabled,
  handleModalConfirmation
}: SubmitButtonSessionProps) => {
  return (
    <div className="tw-w-full tw-max-w-[905px] tw-flex tw-justify-end tw-gap-[20px] tw-pt-[30px] tw-pb-[30px]">
      <button
        className="tw-w-[150px] tw-h-[44px] tw-bg-[#FFFFFF] tw-text-[#1C375C] tw-font-bold tw-focus:outline-none tw-focus:shadow-outline tw-border-2 tw-border-[#001E64] tw-rounded-[7px]"
        onClick={() => handleModalConfirmation('open-cancel-modal')}
      >
        Cancelar
      </button>
      <button
        className={`tw-w-[150px] tw-h-[44px] ${
          isSubmitButtonDisabled
            ? 'tw-bg-[#AAAAAA] tw-border-[#AAAAAA] tw-cursor-not-allowed'
            : 'tw-bg-[#FA6B25] tw-border-[#FA6B25]'
        } tw-text-[#FFFFFF] tw-font-bold  tw-focus:outline-none tw-focus:shadow-outline tw-border-2 tw-rounded-[7px]`}
        onClick={() => handleModalConfirmation('open-submit-modal')}
        disabled={isSubmitButtonDisabled}
      >
        Submeter
      </button>
    </div>
  );
};
